<template>
    <vue-final-modal
        v-model="show"
        name="welcome-modal"
        classes="vizion-modal-container cta-modal"
        content-class="vizion-modal-content"
        :esc-to-close="true"
    >
        <button class="vizion-modal-close" @click="handleClose">
            <span>X</span>
            <!--<i class="fas fa-times"></i>-->
        </button>

        <div class="cnt" :style="{ backgroundColor: bgColor }">
            <div>
                <div v-html="content"></div>
                <div class="vizion-modal-buttons">
                    <a href="#"
                       class="button primary"
                       rel="nofollow"
                       @click.prevent="show = false">
                        {{ textContinueShopping }}
                        <img src="/img/icons/btn-arrow-right.svg" v-svg-inline>
                    </a>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import { inject, onMounted, reactive, toRefs } from 'vue'
import axios from 'axios'

export default {

    props: ['cartTotal', 'currentRoute', 'currentRouteParameters', 'textContinueShopping', 'cartContent', 'modalCookies'],

    emits: ['closed'],

    setup(props, {emit}) {

        const state = reactive({
            show: false,
            content: '',
            bgColor: '',
        })

        const emitter = inject('emitter')

        onMounted( () => {
            let parameters = JSON.parse(props.currentRouteParameters)

            let modalPrefix = ''
            let modalAt = ''
            let target = ''

            if (props.currentRoute.includes('category.detail')) {
                modalPrefix = 'listingProduct'
                modalAt = 'listing'
                target = parameters.slug
            }
            else if (props.currentRoute.includes('product.detail')) {
                modalPrefix = 'listingProduct'
                modalAt = 'product'
                target = parameters.slug
            }
            if (props.currentRoute.includes('get.cart1')) {
                modalPrefix = 'cart'
                modalAt = 'cart'
            }

            // ak je definované aký modal sa má zobraziť a kde
            if (modalAt && modalPrefix) {
                setTimeout(function () {
                    axios.post('/api/get-modal-to-display', {
                        modal_prefix: modalPrefix,
                        modal_at: modalAt,
                        target: target,
                        cart_content: props.cartContent,
                        cart_total: props.cartTotal,
                        modal_cookies: props.modalCookies,
                    })
                    .then( response => {
                        let modalData = response.data.modal
                        let modalCookieIdentificator = response.data.modal_cookie
                        let isJson = false
                        try {
                            JSON.parse(JSON.stringify(modalData));
                            isJson = true
                        } catch (e) { }
                        if (modalCookieIdentificator && isJson && modalData.hasOwnProperty("content")) {
                            state.content = modalData.content.data
                            state.bgColor = modalData.content.bg_color
                            state.show = true
                        }
                        if (modalCookieIdentificator) {
                            if (!checkCookie(modalCookieIdentificator)) {
                                setCookie(modalCookieIdentificator, modalCookieIdentificator, 24);
                            }
                        }
                    })
                    .catch( error => {
                        console.log(error)
                    })
                }, 2000);
            }
        })

        function checkCookie(name) {
            let cookies = document.cookie.split('; ');

            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].split('=');
                if (cookie[0] === name) {
                    return true;
                }
            }

            return false;
        }

        function setCookie(name, value, hours) {
            let date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            let expires = "expires=" + date.toUTCString();
            document.cookie = name + "=" + value + "; " + expires + "; path=/";
        }

        function handleClose() {
            state.show = false;
            emit('closed')
        }

        return {
            ...toRefs(state),
            handleClose,
        }
    }
}
</script>
